{
  "de": {
    "ticket": {
      "actions": {
        "assignCustomer": "Vorgang abschließen",
        "bulk_assign_new_emp": "Massenzuweisung neuer Verantwortlicher",
        "close": "Schließen",
        "create_new": "Neue Konversation erstellen",
        "customer_new_ticket": "Neue Konversation",
        "delete": "Löschen",
        "edit": "Bearbeiten",
        "existing_conversation": "Bestehende Konversation",
        "goToConversation": "Zur Konversation gehen",
        "move_to_existing": "Nachricht in bestehende Konversation verschieben",
        "new": "Konversation",
        "new_aria_label": "Neue Konversation starten",
        "new_conversation": "Neue Konversation",
        "reopen": "Erneut öffnen",
        "selectResponsible": "Verantwortlichen auswählen",
        "selectUnit": "Einheit auswählen",
        "show": "Anzeigen",
        "startNew": "Neue Konversation starten"
      },
      "attributes": {
        "status": "Status",
        "statuses": {
          "closed": "Geschlossen",
          "feedback": "Rückmeldung ausstehend",
          "ongoing": "Laufend",
          "open": "Offen"
        },
        "title": "Titel"
      },
      "editor": {
        "tooltips": {
          "bold": "Fett",
          "bulletList": "Aufzählungsliste",
          "highlight": "Hervorhebung",
          "italic": "Kursiv",
          "link": "Link",
          "orderedList": "Nummerierte Liste",
          "redo": "Wiederholen",
          "strike": "Durchgestrichen",
          "textColor": "Textfarbe",
          "underline": "Unterstrichen",
          "undo": "Rückgängig machen",
          "unlink": "Link entfernen"
        }
      },
      "labels": {
        "additionalQuestion": "Haben Sie eine weitere Frage?",
        "all": "Alle",
        "allProjects": "Alle Projekte",
        "allUnits": "Alle Einheiten",
        "assign_conversations": "Konversationen zuweisen von",
        "bulk_assign_new_emp_warning": "Diese Aktualisierung betrifft auch Konversationen, die mit Entscheidungen oder der Nachbetreuung verknüpft sind. Bei den zugehörigen Entscheidungen (dieser betroffenen Konversationen) wird der verantwortliche Mitarbeiter ebenfalls aktualisiert.",
        "cantChangeResponsibleAftercare": "Diese Konversation ist mit einem Nachbetreuungs-Ticket verknüpft. Bitte ändern Sie den Verantwortlichen dort.",
        "cantChangeResponsibleDecision": "Diese Konversation ist mit einer Entscheidung verknüpft. Bitte ändern Sie den Verantwortlichen dort.",
        "cantDelete": "Diese Konversation gehört zu einer Entscheidung und kann nicht gelöscht werden.",
        "cantEdit": "Diese Konversation gehört zu einer Entscheidung. Bearbeiten Sie sie stattdessen über die Entscheidung",
        "changeResponsible": "Ändern",
        "change_responsible": "Verantwortlichen für Konversationen ändern",
        "clientWillRespondSoon": "Wir melden uns so schnell wie möglich bei Ihnen",
        "contact": "Kontakt",
        "contactPerson": "Ihr Ansprechpartner",
        "contactPersonWithName": "Ihr Ansprechpartner bei {name}",
        "conversation_title": "Titel der Konversation",
        "conversations": "Konversationen",
        "create_ticket": "Konversation erstellen",
        "customer": "Kunde",
        "customers": "Kunden",
        "decision": "Welche Entscheidung?",
        "decisionConversation": "Entscheidung",
        "decisionConversations": "Entscheidungen",
        "disabled_unit": "Diese Einheit wurde deaktiviert. Es können keine Nachrichten gesendet werden.",
        "documentAddedBy": "von",
        "documents": "Dokumente",
        "email_forwarding": "E-Mail-Weiterleitung",
        "employee": "Mitarbeiter",
        "export_conversation": "Konversation exportieren",
        "files": "Dateien",
        "filter": "Filter",
        "inbound_by": "Eingegangen von {name}",
        "inbound_emails": "Eingehende E-Mails",
        "info": "Eine Frage, auf die Sie im Bereich {faq_route} keine Antwort gefunden haben? Stellen Sie sie hier! Bitte fassen Sie Ihre Fragen zu klaren Konversationsthemen zusammen, z. B. „Ausstattung“. ",
        "keywords": "Inhalt durchsuchen",
        "lastMessage": "Letzte Nachricht",
        "message": "Nachricht",
        "message_placeholder": "Schreiben Sie hier Ihre Nachricht …",
        "message_subtitle": "Beschreiben Sie Ihre Frage oder Ihr Anliegen",
        "messaged_at_nulls_first_asc": "Älteste Aktivität",
        "messaged_at_nulls_last_desc": "Neueste Aktivität",
        "myProjects": "Meine Projekte",
        "myTickets": "Meine Konversationen",
        "myTicketsTooltip": "Nur Konversationen anzeigen, bei denen Sie verantwortlich sind",
        "name_lower_asc": "Titel A → Z",
        "name_lower_desc": "Titel Z → A",
        "newConversation": "Neue Konversation",
        "newMessage": "Neue Nachricht",
        "newMessages": "Neue Nachrichten",
        "newWithPartner": "Ziggu und {partner}",
        "newWithZiggu": "Nur Ziggu",
        "noCustomer": "Noch kein Kunde zugewiesen oder eingeladen",
        "noCustomerAssignedToUnit": "Dieser Einheit ist kein Kunde zugewiesen. Möchten Sie fortfahren?",
        "noCustomerAssignedToUnitExplainer": "Hinweis: Sie müssen daher einen anderen Empfänger auswählen.",
        "noCustomerAssignedToUnit_SUP": "Diesem Projekt ist kein Kunde zugewiesen. Möchten Sie fortfahren?",
        "noCustomerInvited": "Der dieser Einheit zugewiesene Kunde wurde noch nicht eingeladen. Möchten Sie fortfahren?",
        "noFiles": "Noch keine Dateien hochgeladen",
        "noMessagesYet": "Noch keine Nachrichten",
        "noTickets": "Keine Konversationen",
        "no_messages": "Konversation hat keine Nachrichten",
        "notSeenYet": "Noch nicht gesehen",
        "notYetDetermined": "Noch nicht festgelegt",
        "note": "Notiz",
        "note_placeholder": "Schreiben Sie nur an Teammitglieder. Geben Sie {'@'} ein, um ein Teammitglied zu erwähnen; es wird benachrichtigt.",
        "onlySelect": "Nur anzeigen",
        "orNewTicket": "Oder eröffnen Sie eine neue zu einem anderen Thema",
        "otherTickets": "Andere Kundenkonversationen",
        "participants": "1 Teilnehmer | {count} Teilnehmer",
        "partner": "Partner",
        "partnerGroup": "Mit wem möchten Sie sprechen?",
        "partnersDecision": "Entscheidungspartner",
        "pendingContactPerson": "Ihr Ansprechpartner antwortet so schnell wie möglich",
        "pendingTickets": "Neue Nachrichten",
        "project": "Projekt",
        "read": "Gelesen",
        "remove_inbound_email": "{email} entfernen?",
        "reply": "Antworten",
        "reply_placeholder": "An alle schreiben",
        "responsible": "Verantwortlich",
        "search": "Suche",
        "search_conversation": "Suche",
        "seen": "Gesehen",
        "seenAll": "alle",
        "seenBy": "Gesehen von {name}",
        "selectLevel": "Ebene auswählen",
        "selectUnit": "Einheit auswählen",
        "show": "Wird angezeigt",
        "showFiles": "Dateien anzeigen",
        "showTicketsFor": "Konversationen anzeigen für",
        "showingAll": "Alle Konversationen",
        "sort": "Sortieren nach",
        "startConversation": "Neue Konversation starten",
        "startConversationForProject": "Neue Konversation im Projekt starten ",
        "startNewConversation": "Neue Konversation starten",
        "subject": "Betreff",
        "subject_subtitle": "Beschreiben Sie es in wenigen Worten",
        "teamMember": "Teammitglied",
        "ticketClosed": "Diese Konversation wurde geschlossen.",
        "ticketClosedByResponsible": "Diese Konversation wurde von {responsible} geschlossen",
        "ticketClosedCustomer": "Wenn Sie eine andere Frage haben, eröffnen Sie bitte eine neue Konversation.",
        "ticketClosedEmployee": "Wenn Sie die Konversation wieder öffnen möchten, ändern Sie den Status oben.",
        "ticket_category": "Kategorie",
        "tickets_all_projects": "Konversationen, alle Projekte",
        "to": "An",
        "unit": "Einheit",
        "unit_name_lower_asc": "Einheit A → Z",
        "unit_name_lower_desc": "Einheit Z → A",
        "unread": "Ungelesen",
        "upload_files": "1 Datei ausstehend | {count} Dateien ausstehend",
        "warning_move_message_to_new_ticket": "Diese Nachricht wird in eine allgemeine Konversation verschoben, die nicht mit einer Entscheidung oder einem Punkt verknüpft ist.",
        "withMentions": "Erwähnt in",
        "withMessages": "Mit Nachrichten",
        "writeMessageToBecomeResponsible": "Schreiben Sie eine Nachricht, um Verantwortlicher zu werden",
        "you": "Sie"
      },
      "messages": {
        "redirect_decision": "Diese Konversation ist Teil einer Entscheidung. Klicken Sie hier, um die Entscheidung anzuzeigen.",
        "redirect_issue": "Diese Konversation ist Teil der Nachbetreuung. Klicken Sie hier, um zur Nachbetreuung zu gehen.",
        "redirect_link": "Details anzeigen"
      },
      "navigation": {
        "backToTickets": "Zurück"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Versuchen Sie, Ihre Fragen zu allgemeinen Konversationsthemen zusammenzufassen, z. B. „Ausstattung“.",
            "title": "Eine Frage? Stellen Sie sie hier!"
          },
          "none": {
            "title": "Keine Konversationen gefunden"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Starten Sie Ihre erste Konversation mit jemandem!",
            "title": "Etwas zu fragen?"
          },
          "none": {
            "subtitle": "Passen Sie die Filter oben auf der Seite an oder folgen Sie einem Projekt, um die zugehörigen Konversationen zu finden",
            "subtitle_aftercare": "Klicken Sie auf das Menü eines Punkts, um eine Konversation zu starten",
            "title": "Keine Konversationen gefunden"
          }
        }
      },
      "toasts": {
        "responsible_updated": "Verantwortlicher erfolgreich aktualisiert!"
      },
      "validation": {
        "mustBeMaximum": "Der Betreff darf {number} Zeichen nicht überschreiten.",
        "needCustomer": "Wählen Sie einen Kunden aus",
        "needMessage": "Nachricht erforderlich",
        "needName": "Titel erforderlich",
        "needResponsible": "Wählen Sie einen Verantwortlichen aus",
        "needSubject": "Betreff erforderlich",
        "needUnit": "Wählen Sie eine Einheit aus"
      }
    }
  }
}
